import {api} from "../config";

export const send_message = (data) =>
  fetch(api + "/contact/message/", {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  })
    .then(response => response)
    .catch(err => console.log(err));
